@if (showParent) {
  <!-- parent wrapper -->
  <div class="weighted-input">
    <!-- optional header -->
    @if (showHeader) {
      <div class="weighted-input__header">
        <label class="form-group__label mb-0">{{question?.question_prompt}}</label>
        @if (showHeaderTotal) {
          <p class="form-control-helper mt-0">
            @if (isPercentage) {
              <span><span>{{total}}</span> of 100 %</span>
            }
            @if (!isPercentage) {
              <span><span>{{total | currency:'ZAR':'R ':'1.0-0'}}</span></span>
            }
          </p>
        }
      </div>
    }
    <!-- <div class="custom-answer__group form-group mb-0"
    [ngClass]="isPercentage ? 'custom-answer__group--percent' : 'custom-answer__group--value'" [id]="uniqueId">
    <app-question-controller *ngFor="let item of childrenQuestions; let i = index;" [question]="item"
      [isEditModal]="isEditModal" (questionAnswer)="onChange($event, i)">
    </app-question-controller>
  </div> -->
  @for (item of childrenQuestions; track item; let i = $index) {
    <app-question-controller
      [question]="item"
      [controlCssClass]="' '"
      [isEditModal]="isEditModal" (questionAnswer)="onChange($event, i)">
    </app-question-controller>
  }
  <!-- optional footer -->
  @if (showFooterTotal) {
    <div class="weighted-input__footer">
      <div class="weighted-input__footer-title">Total</div>
      <div class="weighted-input__footer-number">
        @if (isPercentage) {
          <span><span [ngClass]=" total > 100 ? 'is-invalid' : '' ">{{total}}</span> of 100</span>
        }
        @if (!isPercentage) {
          <span><span>{{total | currency:'ZAR':'R ':'1.0-0'}}</span></span>
        }
        @if (isPercentage) {
          <span>%</span>
        }
      </div>
    </div>
  }
</div>
}

@if (!showParent) {
  <div
    class="custom-answer__group form-group mb-0"
    [ngClass]="isPercentage ? 'custom-answer__group--percent' : 'custom-answer__group--value'"
    [id]="uniqueId">
    @for (item of childrenQuestions; track item; let i = $index) {
      <app-question-controller
        [question]="item"
        (questionAnswer)="onChange($event, i)">
      </app-question-controller>
    }
  </div>
}

